import {
  CLOSE_COIN,
  CLOSE_COIN_FAILED,
  CLOSE_COIN_SUCCESS,
  CLOSE_MARKET,
  CLOSE_MARKET_FAILED,
  CLOSE_MARKET_SUCCESS,
  CREATE_MARKET,
  CREATE_MARKET_FAILED,
  CREATE_MARKET_SUCCESS,
  FETCH_ALL_COIN,
  FETCH_ALL_COIN_FAILED,
  FETCH_ALL_COIN_SUCCEED,
  FETCH_TOMO_COIN,
  FETCH_TOMO_COIN_FAILED,
  FETCH_TOMO_COIN_SUCCEED,
  FETCH_COIN_SETTING,
  FETCH_COIN_SETTING_FAILED,
  FETCH_COIN_SETTING_SUCCEED,
  FETCH_CRYPTO_SETTING,
  FETCH_HASH_SETTING,
  FETCH_INFO_ERC20,
  FETCH_INFO_ERC20_FAILED,
  FETCH_INFO_ERC20_SUCCESS,
  FETCH_TOMO_INFO_ERC20,
  FETCH_TOMO_INFO_ERC20_FAILED,
  FETCH_TOMO_INFO_ERC20_SUCCESS,
  FETCH_LIMIT_WITHDRAWAL,
  FETCH_LIMIT_WITHDRAWAL_FAILED,
  FETCH_LIMIT_WITHDRAWAL_SUCCEED,
  FETCH_MARKET,
  FETCH_MARKET_FAILED,
  FETCH_MARKET_SUCCEED,
  OPEN_COIN,
  OPEN_COIN_FAILED,
  OPEN_COIN_SUCCESS,
  OPEN_MARKET,
  OPEN_MARKET_FAILED,
  OPEN_MARKET_SUCCESS,
  POST_COIN_SETTING,
  POST_COIN_SETTING_SUCCEED,
  POST_COIN_SETTING_FAILED,
  SEARCH_COIN,
  SELECT_COIN,
  UPDATE_COIN,
  UPDATE_COIN_FAILED,
  UPDATE_COIN_SUCCESS,
  UPDATE_LIMIT_WITHDRAWAL,
  UPDATE_LIMIT_WITHDRAWAL_SUCCESS,
  UPDATE_LIMIT_WITHDRAWAL_FAILED,
  ADD_CUSTOM_ACTION,
  ADD_CUSTOM_ACTION_FAILED,
  ADD_CUSTOM_ACTION_SUCCEED,
  FETCH_CRYPTO_EXCHANGE_CONFIG,
  FETCH_CRYPTO_EXCHANGE_CONFIG_SUCCEED,
  FETCH_CRYPTO_EXCHANGE_CONFIG_FAILED,
  FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO,
  FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED,
  FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED,
  DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO,
  DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED,
  DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED,
  ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO,
  ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_FAILED,
  ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_SUCCEED,
  UPDATE_CRYPTO_EXCHANGE_CONFIG, UPDATE_CRYPTO_EXCHANGE_CONFIG_FAILED, UPDATE_CRYPTO_EXCHANGE_CONFIG_SUCCEED,
} from './action_types';

export default {
  fetchCoinSettingAction: () => ({
    type: FETCH_COIN_SETTING,
  }),
  fetchCoinSettingActionSucceed: (data) => ({
    type: FETCH_COIN_SETTING_SUCCEED,
    params: {
      data,
    },
  }),
  fetchCoinSettingActionFailed: (err) => ({
    type: FETCH_COIN_SETTING_FAILED,
    err,
  }),

  fetchMarketAction: () => ({
    type: FETCH_MARKET,
  }),
  fetchMarketActionSucceed: (data) => ({
    type: FETCH_MARKET_SUCCEED,
    params: {
      data,
    },
  }),
  fetchMarketActionFailed: (err) => ({
    type: FETCH_MARKET_FAILED,
    err,
  }),

  fetchAllCoinAction: () => ({
    type: FETCH_ALL_COIN,
  }),
  fetchAllCoinActionSucceed: (data) => ({
    type: FETCH_ALL_COIN_SUCCEED,
    params: {
      data,
    },
  }),
  fetchAllCoinActionFailed: (err) => ({
    type: FETCH_ALL_COIN_FAILED,
    err,
  }),

  fetchLimitWithdrawalAction: (data) => ({
    type: FETCH_LIMIT_WITHDRAWAL,
    params: {
      data,
    },
  }),
  fetchLimitWithdrawalSucceedAction: (data, coins) => ({
    type: FETCH_LIMIT_WITHDRAWAL_SUCCEED,
    data,
    coins,
  }),
  fetchLimitWithdrawalFailedAction: (err) => ({
    type: FETCH_LIMIT_WITHDRAWAL_FAILED,
    err,
  }),

  fetchCryptoSetting: (data_setting) => ({
    type: FETCH_CRYPTO_SETTING,
    params: {
      data_setting,
    },
  }),
  fetchHashSetting: () => ({
    type: FETCH_HASH_SETTING,
  }),
  postCoinSetting: (params) => ({
    type: POST_COIN_SETTING,
    params,
  }),
  postCoinSettingSucceed: (data) => ({
    type: POST_COIN_SETTING_SUCCEED,
    params: {
      data,
    },
  }),
  postCoinSettingFailed: (err) => ({
    type: POST_COIN_SETTING_FAILED,
    err,
  }),

  fetchTomoCoin: (params) => ({
    type: FETCH_TOMO_COIN,
    params,
  }),
  fetchTomoCoinActionSucceed: (data) => ({
    type: FETCH_TOMO_COIN_SUCCEED,
    params: {
      data,
    },
  }),
  fetchTomoCoinActionFailed: (err) => ({
    type: FETCH_TOMO_COIN_FAILED,
    err,
  }),

  selectCoin: (coin) => ({
    type: SELECT_COIN,
    params: {
      coin,
    },
  }),
  searchCoin: (coin) => ({
    type: SEARCH_COIN,
    params: {
      coin,
    },
  }),

  updateCoinAction: (params, callback) => ({
    type: UPDATE_COIN,
    params,
    callback,
  }),
  updateCoinActionSucceed: (data) => ({
    type: UPDATE_COIN_SUCCESS,
    data,
  }),
  updateCoinActionFailed: (err) => ({
    type: UPDATE_COIN_FAILED,
    err,
  }),

  updateLimitWithdrawalAction: (params, callback) => ({
    type: UPDATE_LIMIT_WITHDRAWAL,
    params,
    callback,
  }),
  updateLimitWithdrawalActionSucceed: (data) => ({
    type: UPDATE_LIMIT_WITHDRAWAL_SUCCESS,
    data,
  }),
  updateLimitWithdrawalActionFailed: (err) => ({
    type: UPDATE_LIMIT_WITHDRAWAL_FAILED,
    err,
  }),

  fetchInfoERC20Action: (params, callback) => ({
    type: FETCH_INFO_ERC20,
    params,
    callback,
  }),

  fetchInfoERC20ActionSucceed: (data, callback) => ({
    type: FETCH_INFO_ERC20_SUCCESS,
    data,
    callback,
  }),

  fetchInfoERC20ActionFailed: (err, callback) => ({
    type: FETCH_INFO_ERC20_FAILED,
    err,
    callback,
  }),

  fetchTomoInfoERC20Action: (params, callback) => ({
    type: FETCH_TOMO_INFO_ERC20,
    params,
    callback,
  }),

  fetchTomoInfoERC20ActionSucceed: (data, callback) => ({
    type: FETCH_TOMO_INFO_ERC20_SUCCESS,
    data,
    callback,
  }),

  fetchTomoInfoERC20ActionFailed: (err, callback) => ({
    type: FETCH_TOMO_INFO_ERC20_FAILED,
    err,
    callback,
  }),

  createMarketAction: (params, callback) => ({
    type: CREATE_MARKET,
    params,
    callback,
  }),
  createMarketActionSucceed: (data) => ({
    type: CREATE_MARKET_SUCCESS,
    data,
  }),
  createMarketActionFailed: (err) => ({
    type: CREATE_MARKET_FAILED,
    err,
  }),

  closeMarketAction: (params) => ({
    type: CLOSE_MARKET,
    params,
  }),
  closeMarketActionSucceed: (data) => ({
    type: CLOSE_MARKET_SUCCESS,
    data,
  }),
  closeMarketActionFailed: (err) => ({
    type: CLOSE_MARKET_FAILED,
    err,
  }),

  openMarketAction: (params) => ({
    type: OPEN_MARKET,
    params,
  }),
  openMarketActionSucceed: (data) => ({
    type: OPEN_MARKET_SUCCESS,
    data,
  }),
  openMarketActionFailed: (err) => ({
    type: OPEN_MARKET_FAILED,
    err,
  }),

  openCoinAction: (params) => ({
    type: OPEN_COIN,
    params,
  }),
  openCoinActionSucceed: (data) => ({
    type: OPEN_COIN_SUCCESS,
    data,
  }),
  openCoinActionFailed: (err) => ({
    type: OPEN_COIN_FAILED,
    err,
  }),

  closeCoinAction: (params) => ({
    type: CLOSE_COIN,
    params,
  }),
  closeCoinActionSucceed: (data) => ({
    type: CLOSE_COIN_SUCCESS,
    data,
  }),
  closeCoinActionFailed: (err) => ({
    type: CLOSE_COIN_FAILED,
    err,
  }),

  addCustomCoinAction: (params) => ({
    type: ADD_CUSTOM_ACTION,
    params,
  }),

  addCustomCoinActionFailed: (err) => ({
    type: ADD_CUSTOM_ACTION_FAILED,
    err,
  }),

  addCustomCoinActionSucceed: (params) => ({
    type: ADD_CUSTOM_ACTION_SUCCEED,
    params,
  }),

  fetchCryptoExchangeConfigAction: () => ({
    type: FETCH_CRYPTO_EXCHANGE_CONFIG,
  }),

  fetchCryptoExchangeConfigActionFailed: (err) => ({
    type: FETCH_CRYPTO_EXCHANGE_CONFIG_FAILED,
    err,
  }),

  fetchCryptoExchangeConfigActionSucceed: (params) => ({
    type: FETCH_CRYPTO_EXCHANGE_CONFIG_SUCCEED,
    params,
  }),

  updateCryptoExchangeConfigAction: (params, callback) => ({
    type: UPDATE_CRYPTO_EXCHANGE_CONFIG,
    params,
    callback,
  }),

  updateCryptoExchangeConfigActionFailed: (err) => ({
    type: UPDATE_CRYPTO_EXCHANGE_CONFIG_FAILED,
    err,
  }),

  updateCryptoExchangeConfigActionSucceed: (params) => ({
    type: UPDATE_CRYPTO_EXCHANGE_CONFIG_SUCCEED,
    params,
  }),

  fetchListPublicKeyActiveListCryptoAction: (params, callback) => ({
    type: FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO,
    params,
    callback,
  }),

  fetchListPublicKeyActiveListCryptoActionFailed: (err) => ({
    type: FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED,
    err,
  }),

  fetchListPublicKeyActiveListCryptoActionSucceed: (data) => ({
    type: FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED,
    data,
  }),

  deletePublicKeyActiveListCryptoAction: (params, callback) => ({
    type: DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO,
    params,
    callback,
  }),

  deletePublicKeyActiveListCryptoActionFailed: (err) => ({
    type: DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED,
    err,
  }),

  deletePublicKeyActiveListCryptoActionSucceed: () => ({
    type: DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED,
  }),

  addPublicKeyToActiveListCryptoAction: (params, callback) => ({
    type: ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO,
    params,
    callback,
  }),

  addPublicKeyToActiveListCryptoActionFailed: (err) => ({
    type: ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_FAILED,
    err,
  }),

  addPublicKeyToActiveListCryptoActionSucceed: () => ({
    type: ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_SUCCEED,
  }),
};
